/**
 * Utility functions for iframe detection and communication
 */

/**
 * Detects if the app is running inside an iframe
 */
export const isInIframe = (): boolean => {
  try {
    return window.self !== window.top;
  } catch (e) {
    // If we can't access window.top due to cross-origin, we're definitely in an iframe
    return true;
  }
};

/**
 * Checks if embedded mode is enabled via URL parameter
 */
export const isEmbeddedMode = (): boolean => {
  const params = new URLSearchParams(window.location.search);
  return params.get('embedded') === 'true' || isInIframe();
};

/**
 * Sends height update to parent window
 */
export const sendHeightToParent = (height: number): void => {
  if (!isInIframe()) return;

  try {
    window.parent.postMessage(
      {
        type: 'maroline-resize',
        height: height,
        source: 'maroline-microsite'
      },
      '*' // In production, replace with specific domain: 'https://subzero-wolf.com'
    );
  } catch (e) {
    console.warn('Failed to send height to parent:', e);
  }
};

/**
 * Sends navigation event to parent window
 */
export const sendNavigationToParent = (path: string): void => {
  if (!isInIframe()) return;

  try {
    window.parent.postMessage(
      {
        type: 'maroline-navigation',
        path: path,
        source: 'maroline-microsite'
      },
      '*' // In production, replace with specific domain: 'https://subzero-wolf.com'
    );
  } catch (e) {
    console.warn('Failed to send navigation to parent:', e);
  }
};

/**
 * Sends booking confirmation event to parent window
 */
export const sendBookingConfirmationToParent = (bookingId: string): void => {
  if (!isInIframe()) return;

  try {
    window.parent.postMessage(
      {
        type: 'maroline-booking-confirmed',
        bookingId: bookingId,
        source: 'maroline-microsite'
      },
      '*' // In production, replace with specific domain: 'https://subzero-wolf.com'
    );
  } catch (e) {
    console.warn('Failed to send booking confirmation to parent:', e);
  }
};
